import { render, staticRenderFns } from "./FornecedorForm.vue?vue&type=template&id=5175a20e&"
import script from "./FornecedorForm.vue?vue&type=script&lang=js&"
export * from "./FornecedorForm.vue?vue&type=script&lang=js&"
import style0 from "./FornecedorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports